<div class="details-container" [class.hide]="!show || !showHideFromInside">
    <div class="tree-layout-container">
        <div class="title">
            <div class="img-container autocad">
                <ng-content select="#first-title"></ng-content>
            </div>
            <div class="img-container workroads">
                <ng-content select="#second-title"></ng-content>
            </div>
        </div>
        <div class="tree-container scroll">
            <div class="tree">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
    <div
        class="global-editor-toggle-container"
        [class.open]="show && showHideFromInside"
        *ngIf="show"
    >
        <app-custom-button
            color="primary"
            type="flat"
            size="auto"
            [icon]="showHideFromInside ? 'chevron_right' : 'chevron_left'"
            (buttonClick)="onToggle()"
        ></app-custom-button>
    </div>
    <div class="code-editor-container">
        <ng-content
            select="#global-editor"
            *ngIf="show && showHideFromInside"
            @slideInOut
        ></ng-content>
    </div>
</div>
